module.exports = __webpack_public_path__ + "static/ofcar5-985febdef9836dbad1d6647331c2293f.jpg";